export default __webpack_public_path__ + "54f7300ffa2adffc491a77810a51b13e.js";